import * as Sentry from '@sentry/react'
import { useState } from 'react'
import { useApolloClient } from '@apollo/client'
import { searchStorySets } from '../../graphql/StorySet/searchStorySets'
import {
  SearchStorySets,
  SearchStorySets_searchStorySets_docs
} from '../../graphql/StorySet/__generated__/SearchStorySets'
import { useNotifications } from '../Notifications'

export const useStorySets = () => {
  const apollo = useApolloClient()
  const { addNotification } = useNotifications()
  const [storySets, setStorySets] = useState<SearchStorySets_searchStorySets_docs[]>([])
  const [totalCount, setTotalCount] = useState(0)
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(true)

  const loadStorySets = async () => {
    try {
      const { data } = await apollo.query<SearchStorySets>({
        fetchPolicy: 'no-cache',
        query: searchStorySets,
        variables: { page, items: 15 }
      })

      setStorySets(storySets.concat(data.searchStorySets?.docs || []))
      setTotalCount(data?.searchStorySets?.totalDocs || 0)
    }
    catch (err) {
      addNotification({ message: err.message, type: 'error', interval: 10000 })
      Sentry.captureException(err)
    }
    finally {
      setLoading(false)
    }
  }

  return {
    storySets,
    totalCount,
    page,
    loading,
    actions: { setPage, loadStorySets }
  }
}
